export const PROFESSION_LABEL: Record<string, string> = {
  judicial:       "司法書士",
  administrative: "行政書士",
  surveyor:       "調査士",
  common:         "共通",
  other:          "その他",
};

export const PROFESSION_COLOR: Record<string, string> = {
  judicial:       "#0f766e",
  administrative: "#7c3aed",
  surveyor:       "#b45309",
  common:         "#475569",
  other:          "#64748b",
};

export const WORK_CATEGORY_LABEL: Record<string, string> = {
  fee:              "報酬",
  registration_tax: "登録税",
  stamp:            "印紙税",
  postage:          "郵送料",
  pass_through:     "立替金",
  withholding:      "源泉所得税",
  consumption_tax:  "消費税",
  other:            "その他",
};

export const TAX_CATEGORY_LABEL: Record<string, string> = {
  taxable:      "課税",
  non_taxable:  "非課税",
  tax_exempt:   "免税",
  out_of_scope: "対象外",
};

// category ごとの既定値
export function getDefaultTaxCategory(category: string): string {
  const map: Record<string, string> = {
    fee:              "taxable",
    registration_tax: "out_of_scope",
    stamp:            "out_of_scope",
    postage:          "out_of_scope",
    pass_through:     "out_of_scope",
    withholding:      "out_of_scope",
    consumption_tax:  "out_of_scope",
  };
  return map[category] ?? "taxable";
}

export function getDefaultIsPassThrough(category: string): boolean {
  return ["registration_tax", "stamp", "postage", "pass_through"].includes(category);
}

export function getDefaultWithholdingTarget(category: string, profession: string): boolean {
  if (category !== "fee") return false;
  return profession === "judicial" || profession === "surveyor";
}
